import React from 'react';
import './button.css';

export default ({ children, onClickHandler, id, style, classStyle, dataTip, disabled }) => {
    function handleClick(e) {
        if (disabled) return;          // ✅ block the click when disabled
        if (onClickHandler) onClickHandler(e);
    }

    return (
        <div
            id={id}
            className={`${classStyle || 'button'}${disabled ? ' button--disabled' : ''}`}
            onClick={handleClick}
            style={style}
            data-tip={dataTip}
            aria-disabled={disabled}   // ✅ accessibility
        >
            {children}
        </div>
    );
};